module.exports = __webpack_public_path__ + "static/media/sparkLoginLogo.979073de.svg";